class BlogFilter extends HTMLElement {
  constructor() {
    super();

    const filter = document.querySelector('select');
    filter.addEventListener('change', function() {
      window.location.href = filter.value;
    });
  }
}

customElements.define('blog-filter', BlogFilter);



document.addEventListener('DOMContentLoaded', () => {
  const loadMoreBtn = document.querySelector('.load-more-btn');

  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    const nextUrl = loadMoreBtn.dataset.nextUrl;

    if (!nextUrl) return;

    loadMoreBtn.classList.add('loading');

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#blog-grid');

      if (newGrid) {
        document
          .querySelector('#blog-grid')
          .insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      const nextButton = doc.querySelector('.load-more-btn');

      if (nextButton) {
        loadMoreBtn.dataset.nextUrl =
          nextButton.dataset.nextUrl;
      } else {
        loadMoreBtn.remove();
      }
    } catch (error) {
      console.error('Load More Error:', error);
    }

    loadMoreBtn.classList.remove('loading');
  });
});